import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function ProcessSection() {
  const {
    lang
  } = useLanguage();
  const steps = [{
    n: '01',
    title: 'Sesión Diagnóstico',
    titleEn: 'Diagnostic Session',
    text: 'Analizamos tu situación, identificamos qué necesitas y te entregamos un plan claro. 30 minutos que lo cambian todo.',
    textEn: 'We analyze your situation, identify what you need, and deliver a clear plan. 30 minutes that change everything.'
  }, {
    n: '02',
    title: 'Estrategia e identidad',
    titleEn: 'Strategy & identity',
    text: 'Definimos tu mensaje, tu posicionamiento y la identidad visual que te representa con autenticidad.',
    textEn: 'We define your message, your positioning, and the visual identity that represents you authentically.'
  }, {
    n: '03',
    title: 'Construcción',
    titleEn: 'Construction',
    text: 'Diseñamos y desarrollamos tu presencia digital completa — web, sistema de cobro, dominio y más.',
    textEn: 'We design and develop your complete digital presence — website, payment system, domain, and more.'
  }, {
    n: '04',
    title: 'Lanzamiento y acompañamiento',
    titleEn: 'Launch & accompaniment',
    text: 'Recibes todo listo, con un dashboard claro y acompañamiento real para crecer con propósito.',
    textEn: 'You receive everything ready, with a clear dashboard and real accompaniment to grow with purpose.'
  }];
  return <section id="proceso" className="py-12 lg:py-20 bg-[#F0EDFB]" data-id="element-349">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-350">
        {/* ─────────────── HEADER ─────────────── */}
        <div className="mb-10 lg:mb-16 max-w-2xl" data-id="element-351">
          <span className="block font-sans text-[10px] font-bold tracking-[3px] uppercase text-[#5A4579] mb-5 lg:mb-8" data-id="element-352">
            {lang === 'es' ? 'NUESTRO PROCESO' : 'OUR PROCESS'}
          </span>
          <h2 className="font-serif text-[19px] sm:text-[3.4vw] lg:text-[44px] leading-[1.1] tracking-[-0.5px] text-[#1A1A2E] whitespace-nowrap" data-id="element-353">
            {lang === 'es' ? <>
                Un camino con{' '}
                <em className="italic text-[#5A4579]" data-id="element-354">claridad</em> en cada
                paso.
              </> : <>
                A path with <em className="italic text-[#5A4579]" data-id="element-355">clarity</em>{' '}
                at every step.
              </>}
          </h2>
        </div>

        {/* ─────────────── TIMELINE ─────────────── */}
        <div className="relative" data-id="element-356">
          {/* Vertical line track (faint) */}
          <span aria-hidden="true" className="absolute top-0 bottom-0 w-[2px] left-[24px] lg:left-[48px] bg-[rgba(90,69,121,0.12)]" data-id="element-357" />
          {/* Vertical line — draws itself top → bottom on scroll */}
          <motion.span aria-hidden="true" initial={{
          scaleY: 0
        }} whileInView={{
          scaleY: 1
        }} viewport={{
          once: true,
          margin: '-10% 0px -10% 0px'
        }} transition={{
          duration: 1.2,
          ease: 'easeOut'
        }} style={{
          originY: 0
        }} className="absolute top-0 bottom-0 w-[2px] left-[24px] lg:left-[48px] bg-[linear-gradient(to_bottom,#5A4579,#A78BCA)]" data-id="element-358" />

          <div className="flex flex-col gap-6 lg:gap-10" data-id="element-359">
            {steps.map((step, index) => <motion.div key={step.n} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            ease: 'easeOut',
            delay: index * 0.15
          }} className="relative" data-id="element-360">
                {/* Node on the line */}
                <motion.div initial={{
              scale: 1
            }} whileInView={{
              scale: [1, 1.15, 1]
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              ease: 'easeOut',
              delay: index * 0.15 + 0.2
            }} className="absolute top-0 left-[24px] lg:left-[48px] -translate-x-1/2 z-10 flex items-center justify-center rounded-full bg-[#5A4579] border-[3px] border-[#F0EDFB] shadow-[0_0_0_4px_rgba(90,69,121,0.2)] w-[32px] h-[32px] lg:w-[40px] lg:h-[40px]" data-id="element-361">
                  <span className="font-display font-bold text-white text-[13px] lg:text-[16px] leading-none" data-id="element-362">
                    {step.n}
                  </span>
                </motion.div>

                {/* Connector line from node to card */}
                <span aria-hidden="true" className="absolute top-[16px] lg:top-[20px] h-[1.5px] w-[20px] bg-[#5A4579] left-[40px] lg:left-[68px]" data-id="element-363" />

                {/* Content card */}
                <div className="ml-[56px] lg:ml-[80px] max-w-[560px] bg-white rounded-[16px] p-[18px] lg:p-6 shadow-[0_4px_20px_rgba(90,69,121,0.08)]" data-id="element-364">
                  <h3 className="font-sans font-bold text-[17px] text-[#1A1A2E] leading-tight mb-2" data-id="element-365">
                    {lang === 'es' ? step.title : step.titleEn}
                  </h3>
                  <p className="text-[14px] text-[#4B5563] font-normal leading-[1.7]" data-id="element-366">
                    {lang === 'es' ? step.text : step.textEn}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}